import BoyIcon from 'components/icons/svg/BoyIcon';
import React from 'react';
import styles from './SectionHeader.module.scss';

type SectionHeaderProps = {
  className?: string;
};

const SectionHeader: React.FC<SectionHeaderProps> = ({ className = '' }) => {
  const baseCls = `${styles.SectionHeader} ${className}`;
  return (
    <div className={baseCls}>
      <span className={styles.SectionHeaderItem}>TITLE</span>

      <span className={styles.SectionHeaderItem}>TEAMS</span>

      <span className={styles.SectionHeaderItem}> </span>
      <span className={styles.SectionHeaderItem}>OPEN SQ</span>
      <span className={styles.SectionHeaderItem}>
        <BoyIcon size={24} color="cornsilk" />
      </span>
    </div>
  );
};

export default SectionHeader;
